import React, { useState, useEffect } from 'react'
import { WifiIcon } from '@heroicons/react/24/outline'
import { networkStatus } from '../services/networkStatus.js'

/**
 * An honest offline indicator.
 *
 * The web app requires connectivity to save — there is no working offline
 * write/sync layer (the old sync-queue machinery never actually engaged), so
 * this says plainly that changes won't save while offline rather than implying
 * they are being stored and synced. True field/offline use is the native app's
 * job.
 */
function OfflineBanner() {
  const [online, setOnline] = useState(networkStatus.isOnline)

  useEffect(() => {
    const unsub = networkStatus.subscribe(setOnline)
    return () => unsub()
  }, [])

  if (online) return null

  return (
    <div className="px-4 py-2 text-sm font-medium flex items-center justify-center gap-2 bg-amber-600 text-white">
      <WifiIcon className="w-4 h-4" />
      <span>You're offline — changes won't be saved until you reconnect.</span>
    </div>
  )
}

export default OfflineBanner
